import { Pergunta } from './pergunta';

export class Resposta{
        
    id : number;
    resposta : string;
    pergunta: Pergunta
    
}